import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onClick", "children", "twStyle", "Icon", "isSelected", "isOpen", "imageUrl", "indicator", "newTab", "href", "isLink"],
    _excluded2 = ["$isOpen", "$isSelected", "twStyle"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { forwardRef, useCallback, useState, useEffect } from 'react';
import Image from 'next/image';
import { customImageLoader } from '@restworld/utils-common';
import { notificationIndicatorStyles } from '@restworld/ui-ds-base';
import { V2Link } from '../../feature-components'; // eslint-disable-next-line jsx-a11y/anchor-has-content

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ForwardedLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("a", _objectSpread({
    ref: ref
  }, props));
});
ForwardedLink.displayName = 'ForwardedLink';
export var NavMenuItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var onClick = props.onClick,
      children = props.children,
      twStyle = props.twStyle,
      Icon = props.Icon,
      isSelected = props.isSelected,
      isOpen = props.isOpen,
      imageUrl = props.imageUrl,
      indicator = props.indicator,
      _props$newTab = props.newTab,
      newTab = _props$newTab === void 0 ? false : _props$newTab,
      _props$href = props.href,
      href = _props$href === void 0 ? '#!' : _props$href,
      _props$isLink = props.isLink,
      isLink = _props$isLink === void 0 ? true : _props$isLink,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),
      delayedIsOpen = _useState[0],
      setDelayedIsOpen = _useState[1];

  var handleClick = useCallback(function (e) {
    if (!isLink) e.preventDefault();
    if (onClick) onClick(e);
  }, [isLink, onClick]);
  useEffect(function () {
    var timeoutId; // the expansion on hover of the side nav causes a distortion in the nav item text as it might occupy 2 lines
    //  at the start then occupy one line when the expansion animation ends. This delay before showing the text accounts
    // for that, so users don't experience the text flickering.

    if (isOpen) {
      timeoutId = setTimeout(function () {
        setDelayedIsOpen(isOpen);
      }, 150);
    } else {
      clearTimeout(timeoutId);
      setDelayedIsOpen(!!isOpen);
    }

    return function () {
      clearTimeout(timeoutId);
    };
  }, [isOpen]);
  return /*#__PURE__*/_jsxs(StyledNavMenuItem, _objectSpread(_objectSpread({
    ref: ref,
    href: href,
    $isSelected: isSelected,
    $isOpen: isOpen,
    onClick: handleClick,
    target: newTab ? '_blank' : undefined,
    rel: newTab ? 'noopener noreferrer' : undefined,
    twStyle: twStyle
  }, restProps), {}, {
    children: [imageUrl ? /*#__PURE__*/_jsx(ImageWrapper, {
      children: /*#__PURE__*/_jsx(Image, {
        alt: "",
        src: imageUrl,
        fill: true,
        loader: customImageLoader
      })
    }) : Icon ? /*#__PURE__*/_jsx(Icon, {
      className: "h-6 w-6 min-w-[24px] max-w-[24px]"
    }) : null, delayedIsOpen ? /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(_StyledDiv2, {
        children: children
      }), typeof indicator === 'number' && /*#__PURE__*/_jsx(NotificationIndicator, {
        children: indicator
      })]
    }) : null]
  }));
});
NavMenuItem.displayName = 'NavMenuItem';
export default NavMenuItem;

var StyledNavMenuItem = /*#__PURE__*/_styled(function (_ref) {
  var $isOpen = _ref.$isOpen,
      $isSelected = _ref.$isSelected,
      twStyle = _ref.twStyle,
      rest = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/_jsx(V2Link, _objectSpread({}, rest));
}).withConfig({
  displayName: "nav-menu-item__StyledNavMenuItem",
  componentId: "sc-nkrqjp-0"
})(["", " ", " ", " ", ""], {
  "display": "flex",
  "minHeight": "40px",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "color": "inherit",
  "textDecorationLine": "none",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms",
  ":hover": {
    "cursor": "pointer"
  },
  ":focus-visible": {
    "outlineWidth": "8px",
    "outlineColor": "#e88a99"
  }
}, function (_ref2) {
  var $isSelected = _ref2.$isSelected;
  return $isSelected ? {
    "backgroundColor": "rgb(72 36 133 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(72 36 133 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(72 36 133 / 0.2)"
    }
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(0 0 26 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(0 0 26 / 0.2)"
    }
  };
}, function (_ref3) {
  var $isOpen = _ref3.$isOpen;
  return $isOpen ? {
    "width": "100%"
  } : {
    "width": "fit-content"
  };
}, function (_ref4) {
  var twStyle = _ref4.twStyle;
  return twStyle || {};
});

var ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "nav-menu-item__ImageWrapper",
  componentId: "sc-nkrqjp-1"
})(["", ""], {
  "position": "relative",
  "height": "1.5rem",
  "width": "1.5rem",
  "minWidth": "24px",
  "maxWidth": "24px",
  "overflow": "hidden",
  "borderRadius": "9999px",
  "objectFit": "cover",
  "objectPosition": "center"
});

var NotificationIndicator = /*#__PURE__*/_styled.span.withConfig({
  displayName: "nav-menu-item__NotificationIndicator",
  componentId: "sc-nkrqjp-2"
})(["", ""], notificationIndicatorStyles);

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-item___StyledDiv",
  componentId: "sc-nkrqjp-3"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-item___StyledDiv2",
  componentId: "sc-nkrqjp-4"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
});